module.exports = __webpack_public_path__ + "img/baby-asset.dbed73f1.png";